<template>
    <div id="inform">
        <transition name="fade">
            <Loading v-if="isLoading"/>
        </transition>
        <goTop/>
        <step :stepNumber="3"/>
        <div class="content">
            <div class="container">
                <h2 class="title2">告知事項</h2>
                <div class="checkArea clarity-unmask">
                    <div class="checkList" :id="'checkList' + index" v-for="(item, index) in informList" :key="index + reloadInformKey" @change="checkSelect">
                        <span class="question" v-if="item.informShow">{{ item.informIndex }}.{{ item.informQ }}</span>
                        <span class='icon' @click="showThirdDialog" v-if="item.informKYCType === 'FAMILY'||item.informKYCType === 'ADDR'"></span>
                        <label class="switch" v-if="item.informType === 'CHECK' && item.informShow">
                            <input type="checkbox" class="switch-input" :checked="item.informData"
                                   :id="'inform' + index"
                                   v-model="item.informValue" @click="question3Alert($event)">
                            <span class="switch-label" data-on="是" data-off="否"></span>
                            <span class="switch-handle"></span>
                        </label>
                        <div class="selectBox">
                            <select class="inputStyle arrow " :class="{ 'alert': item.check }"
                                    v-if="item.informType === 'SELECT' && item.informShow" v-model="item.informValue">
                                <option v-for="(content, contentIndex) in item.informData" :value="content.selectValue"
                                        :disabled="contentIndex == 0" :key="contentIndex">{{ content.selectItem }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <p class='attentionTxt' v-if="haveThirdDegreeRelative || haveThirdDegreeRelativeAddr"><img src='noticemark.svg' class='attention'>完成關係宣告後將同步更新您的會員資料。</p>
            </div>
        </div>
        <div class="btnArea">
            <div class="anotherBtn">
                <router-link :to="'/detail'" class="btn inform_back_accu">返回</router-link>
                <a class="btn confirm inform_go_accu" @click="checkInformPage">確定</a>
            </div>
        </div>
    </div>
</template>
<script setup>
        import goTop from "@/components/gotop.vue";
        import step from "@/components/step.vue";
        import CheckData from "@/utils/checkData";
        import {postApi} from "@/utils/callApi";
        import Loading from "@/components/loading.vue";
        import LoadData from "@/utils/loadData";
        import {popUp} from "@/utils/popUp";
        import {onMounted, ref} from "vue";
        import gtm from "@/utils/gtmDataLayer";
        import Swal from 'sweetalert2'
        import {useRouter} from "vue-router";
        import apiConfig from "@/utils/apiConfig";
        import $ from "jquery";

        const router = useRouter();

        let haveResident = false;
        let haveThirdDegreeRelative = ref(true);
        let haveThirdDegreeRelativeAddr = ref(true);
        let kycQuestion = "";
        let kycQuestionAddr = "";
        let startCheck = false;

        let detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));
        let insTraOrderId = sessionStorage.getItem("insTraOrderId");
        let jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));


        let informList = ref([]);
        const isLoading = ref(false);
        const reloadInformKey = ref(0);

        const checkLogin = () => {
            let checkPage = true;
            const message = [];

            if (insTraOrderId === "" || insTraOrderId === null) {
                checkPage = false;
                message.push('流程錯誤，請重新投保');
            }
            if (jwtInfo == null) {
                checkPage = false;
                message.push('頁面逾期，請重新投保');
            }
            if (checkPage) {
                loadInformPage();
            } else {
                Swal.fire({
                    title: "頁面錯誤",
                    confirmButtonText: "確定",
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>'+ message + '</p>',
                }).then(() => {
                    router.push('/');
                });
            }
        }
        const loadInformPage = () => {
            if (detailStorage.informList != null) {
                informList.value = detailStorage.informList;
            } else {
                //檢查是否有居留證者
                detailStorage.insureData.forEach((insure) => {
                    if (CheckData.id(insure.insureIdNo) === 'resident') {
                        haveResident = true;
                    }
                });
                //檢查三親等 callApi再產
                var data = {
                    'insTraOrderId': insTraOrderId,
                    'isSync': detailStorage.applicantData.syncMember,
                };
                jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
                postApi(apiConfig.checkContactInfo, jwtInfo.token, null, null, data)
                    .then((response) => {
                        var checkContactInfoRes = response.data;
                        if (checkContactInfoRes.code === 200) {

                            kycQuestion = checkContactInfoRes.data.emailAndMobQuestion;
                            kycQuestionAddr = checkContactInfoRes.data.addressQuestion;
                            if(kycQuestion === "C"){
                                haveThirdDegreeRelative.value = false;
                            }

                            if(kycQuestionAddr === "C"){
                                haveThirdDegreeRelativeAddr.value = false;
                            }

                            getKycList();
                        } else {
                            Swal.fire({
                                title: "檢查三親等錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg" alt="error"><p>'+ checkContactInfoRes.message + '</p>',
                            });
                        }
                    })
                    .catch(() => {
                        Swal.fire({
                            title: "檢查三親等錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>檢查資料連線錯誤</p>'
                        });
                    });
            }
        }
        //載入KYC清單
        const getKycList = () =>{
            LoadData.getKyc(function (data) {
                createInformList(data);
            });
        }
        const createInformList = (kycList) => {
            kycList.forEach(kyc => {
                let informShow = false;
                switch(kyc.informKYCType){
                    case "APPLICANT":
                        informShow = true;
                        break;
                    case "ROSTER":
                        informShow = true;
                        break;
                    case "RESIDENT":
                        informShow = haveResident;
                        break;
                    case "FAMILY":
                        informShow = haveThirdDegreeRelative;
                        break;

                    case "ADDR":
                        informShow = haveThirdDegreeRelativeAddr;
                        break;
                }
                switch (kyc.informID){
                    case 11:
                        if (kycQuestion === "A") {
                            informShow = true;
                        } else {
                            informShow = false;
                        }
                        break;
                    case 25:
                        if (kycQuestion === "B") {
                            informShow = true;
                        } else {
                            informShow = false;
                        }
                        break;

                    case 27:
                        if (kycQuestionAddr === "A") {
                            informShow = true;
                        } else {
                            informShow = false;
                        }
                        break;
                    case 26:
                        if (kycQuestionAddr === "B") {
                            informShow = true;
                        } else {
                            informShow = false;
                        }
                        break;
                }
                var informValue = "";
                switch(kyc.informType){
                    case "CHECK":
                        informValue = false;
                        break;
                    case "SELECT":
                        informValue = "";
                        break;
                }

                kyc.informIndex = 0;
                kyc.informShow = informShow;
                kyc.informValue = informValue;
                kyc.check = false;
            });

            //產出informList
            informList.value = kycList;

            //informIndex
            let index = 0;
            informList.value.forEach(inform => {
                if (inform.informShow) {
                    index += 1;
                    inform.informIndex = index;
                }
            });
        }
        const showThirdDialog = () => {
            var relativesCon =
                '<div class="tableDiv">'+
                '<h3>一親等</h3>'+
                '<div class="relativeTable">'+
                '<div class="css_table">'+
                '<div class="css_caption importTitle">血親</div>'+
                '<div class="css_caption"><div class="css_td">父母、子女</div></div>'+
                '<div class="css_caption importTitle">姻親</div>'+
                '<div class="css_tr blueTitle">血親之配偶</div>'+
                '<div class="css_tr">'+
                '<div class="css_td">父之妻、母之夫<br>子媳、女婿</div></div>'+
                '<div class="css_tr blueTitle">配偶之血親</div>'+
                '<div class="css_tr"><div class="css_td">公婆、岳父母、配偶之子女</div></div>'+
                '<div class="css_tr blueTitle">配偶之血親之配偶</div>'+
                '<div class="css_tr"><div class="css_td">公婆、岳父母之配偶、配偶之子媳、女婿</div></div>'+
                '</div>'+
                '</div>'+
                '</div>'+
                '<div class="tableDiv">'+
                '<h3>二親等</h3>'+
                '<div class="relativeTable">'+
                '<div class="css_table">'+
                '<div class="css_caption importTitle">血親</div>'+
                '<div class="css_caption"><div class="css_td">兄弟姐妹、(外)祖父母<br>(外)孫子女</div></div>'+
                '<div class="css_caption importTitle">姻親</div>'+
                '<div class="css_tr blueTitle">血親之配偶</div>'+
                '<div class="css_tr">'+
                '<div class="css_td">兄嫂、弟媳、姐夫、妹夫、(外)祖父母之配偶、(外)孫子媳、(外)孫女婿</div></div>'+
                '<div class="css_tr blueTitle">配偶之血親</div>'+
                '<div class="css_tr"><div class="css_td">配偶之兄弟姐妹、配偶之(外)祖父母、配偶之(外)孫子女</div></div>'+
                '<div class="css_tr blueTitle">配偶之血親之配偶</div>'+
                '<div class="css_tr"><div class="css_td">配偶之兄嫂、弟媳、姐夫、妹夫、配偶之(外)祖父母之配偶、配偶之(外)孫子媳、(外)孫女婿</div></div>'+
                '</div>'+
                '</div>'+
                '</div>'+
                '<div class="tableDiv">'+
                '<h3>三親等</h3>'+
                '<div class="relativeTable">'+
                '<div class="css_table">'+
                '<div class="css_caption importTitle">血親</div>'+
                '<div class="css_caption"><div class="css_td">伯、叔、姑、舅、姨、姪子女、外甥(女)、(外)曾祖父母、(外)曾孫子女</div></div>'+
                '<div class="css_caption importTitle">姻親</div>'+
                '<div class="css_tr blueTitle">血親之配偶</div>'+
                '<div class="css_tr">'+
                '<div class="css_td">伯母、叔母、姑丈、舅母、姨丈、姪媳/婿、外甥媳/婿、(外)曾祖父母之配偶、(外)曾孫子媳、(外)曾孫女婿</div></div>'+
                '<div class="css_tr blueTitle">配偶之血親</div>'+
                '<div class="css_tr"><div class="css_td">配偶之伯、叔、姑、舅、姨、配偶之姪子女、外甥(女)、配偶之(外)曾祖父母、配偶之(外)曾孫子女</div></div>'+
                '<div class="css_tr blueTitle">配偶之血親之配偶</div>'+
                '<div class="css_tr"><div class="css_td">配偶之伯母、叔母、姑丈、舅母、姨丈、配偶之姪媳/婿、外甥媳/婿、配偶之(外)曾祖父母之配偶、配偶之(外)曾孫子媳、(外)曾孫女婿</div></div>'+
                '</div>'+
                '</div>'+
                '</div>'
            Swal.fire({
                title: "三親等內之親屬列表",
                showConfirmButton: false,
                showCloseButton: true,
                customClass: {container: "relativePop"},
                html: relativesCon
            });
        }
        const question3Alert = (event) => {
            if (event.target.id === "inform2" && event.target.checked) {
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>很抱歉，網路上暫不接受有【監護宣告】的被保險人投保，造成不便請您見諒。</p>',
                });
            }
        }
        const updateInformData = () => {
            detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));
            detailStorage.informList = informList.value;
            sessionStorage.setItem("detailStorage", JSON.stringify(detailStorage));
        }
        const checkSelect = () =>{
            if(startCheck === true){
                informList.value.forEach((inform) => {
                    if (inform.informType === 'SELECT') {
                        if (inform.informValue === "") {
                            inform.check = true;
                        } else {
                            inform.check = false;
                        }
                    }
                });
            }
        }
        const checkInformPage = () => {
            startCheck = true; //開始監聽檢核
            //檢查KYC
            var checkFlag = 0;
            var errorMsg = [];
            informList.value.forEach((inform) => {
                if (inform.informShow) {
                    if (inform.informType === 'CHECK') {
                        if (inform.informIndex === 3 && inform.informValue) {
                            checkFlag++;
                            errorMsg.push('很抱歉，網路上暫不接受有【監護宣告】的被保險人投保，造成不便請您見諒。');
                        }
                    }
                    if (inform.informType === 'SELECT') {
                        if (inform.informValue === "") {
                            inform.check = true;
                            checkFlag++;
                            errorMsg.push('請回答 問項' + inform.informIndex + ' 問題');
                        } else {
                            inform.check = false;
                        }
                    }
                }
                if (haveThirdDegreeRelative && inform.informID === 11) {
                    if (inform.informValue === "NONE") {
                        checkFlag++;
                        errorMsg.push('若手機與Email不為本人或親屬使用，則無法進行投保');
                    }
                }
                if (haveThirdDegreeRelative && inform.informID === 25) {
                    if (inform.informValue === "NONE") {
                        checkFlag++;
                        errorMsg.push('若手機與Email不為本人或親屬使用，則無法進行投保');
                    }
                }
            });

            reloadInformKey.value += 1;

            if (checkFlag === 0) {
                //組合KYC POST 資料
                const applicantKYC = [];
                const rosterKYC = [];
                var belongValue = '';
                var addrBelongValue = '';

                informList.value.forEach((inform => {
                    switch (inform.informKYCType) {
                        case 'FAMILY':
                            if(inform.informValue !== "") {
                                belongValue = inform.informValue;
                            }
                            break;
                        case 'ADDR':
                            if(inform.informValue !== ""){
                                addrBelongValue = inform.informValue;
                            }
                            break;
                    }
                }));

                isLoading.value = true;
                var contactInfo = {
                    'emailBelong': belongValue,
                    'mobileBelong': belongValue,
                    'addrBelong': addrBelongValue,
                }

                informList.value.forEach((inform => {
                    var kycQA = {
                        'q': inform.informID,
                        'a': inform.informValue,
                    }
                    switch (inform.informKYCType) {
                        case 'APPLICANT':
                            applicantKYC.push(kycQA);
                            break;
                        case 'ROSTER':
                        case 'RESIDENT':
                            rosterKYC.push(kycQA);
                            break;
                    }
                }));

                var data = {
                    'insTraOrderId': insTraOrderId,
                    'applicantKYC': applicantKYC,
                    'rosterKYC': rosterKYC,
                    'contactInfo': contactInfo,
                };

                jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
                postApi(apiConfig.checkKYCPage, jwtInfo.token, null, null, data)
                    .then((response) => {
                        var checkKYCPageRes = response.data;

                        if (checkKYCPageRes.code === 200) {
                            updateInformData();
                            router.push("/confirm");
                        } else {
                            Swal.fire({
                                title: "填寫資料錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg"><p>'+ checkKYCPageRes.message + '</p>',
                            });
                            isLoading.value = false;
                        }
                    })
                    .catch(() => {
                        Swal.fire({
                            title: "資料錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>檢查資料連線錯誤</p>'
                        });
                        isLoading.value = false;
                    });
            } else {
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>'+ errorMsg[0] + '</p>',
                }).then(function () {
                    $(".alertStr").remove();
                    $(".alert").parent().append("<p></p>");
                })
                isLoading.value = false;
            }
        }
        onMounted(()=> {
            popUp();//公告系統
            gtm.pageViewEvent();//新增pageViewEvent
            checkLogin();
        })

</script>
<style lang="scss">
#inform {
  .checkList {
    clear: both;
    @media screen and (max-width: $small) {
      font-size: 16px;
    }

    .switch {
      width: 18%;
      float: right;
      margin: 15px 0;
      margin-bottom: 25px;
      @media screen and (max-width: $small) {
        width: 35%;
      }
    }

    .switch-input {
      position: absolute;
      top: 0;
      left: 0;

      &:checked {
        ~ .switch-label:before {
          color: $textColor;
        }

        ~ .switch-label:after {
          color: #fff;
        }

        ~ .switch-handle {
          right: 50%;
        }
      }
    }

    .switch-label {
      &:before {
        content: attr(data-off);
        right: 20%;
        color: #fff;
      }

      &:after {
        content: attr(data-on);
        left: 20%;
        color: $textColor;
      }
    }

    .switch-handle {
      right: 0;
      left: inherit;
      width: 50%;
      transition: right 0.15s ease-out;
    }

    .inputStyle.arrow {
        width: 45%;
        margin: 15px 0 25px 0;
        float:right;
      @media screen and (max-width: $small) {
        width: 100%;
        margin-bottom: 20px;
      }
    }

     .question + .icon {
      display: inline-block;
      width: 23px;
      height: 23px;
      background-size: contain;
      background-image: url("../assets/question.svg");
      position: relative;
      top: 10px;
      margin-left: 5px;
      cursor: pointer;

    }
  }

  .content {
    overflow: hidden;
  }

  #step::after {
    background-image: url("../assets/yellowBg.svg");
    background-size: 40%;
    background-repeat: no-repeat;
  }
  .inputStyle.arrow.alert{margin-bottom:0;}
}
.relativePop.swal2-container .swal2-popup{
  width:68%;
}
.relativePop .swal2-html-container{
  display:flex !important;justify-content: center
}

.tableDiv{
  width:32.5%;
  margin:0 1%;
  font-size:16px;
  h3{text-align:center;margin:10px auto;}
  .css_caption .css_td{border:0}
}
.relativeTable {
  border-radius: 22px;
  border: 1px solid $btnGray;
  .blueTitle{
    margin:0;
    border:0;
    font-size:16px;
    font-weight:bold;
    line-height:30px;
  }
  .css_td {
    width: 25%;
    box-sizing: border-box;
    padding: 10px;
    font-size:14px;
    line-height:25px;
    height:98px;
    vertical-align: middle;
    text-align: left;
  }
}
@media screen and (max-width: $medium) {
  .relativePop.swal2-container .swal2-popup{
    width:90% !important;
  }
  .relativeTable .css_td{height:120px;}
}
@media screen and (max-width: $pad) {
  .relativePop .swal2-html-container {
    display: block !important;
  }
  .tableDiv{
    width:100%;
    margin:0;
    .css_caption.importTitle{font-size:16px;}
    .relativeTable .css_td{
      font-size:14px;
      line-height:20px;
      height:auto;
    }
    .css_caption .css_td {
      display: inline-block;
      width: 100%;
    }
  }

}
@media screen and (max-width: 414px) {
  .tableDiv .relativeTable .css_td{
    font-size:3vw;
    line-height:20px;
  }


}

</style>
